/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import "./layout.scss"
import { Helmet } from "react-helmet"
import BottomNav from "./navBar/bottomNav"
import PcNav from "./navBar/pcNav"

const Layout = ({ children }) => {
  return (
    <>
      <div>
        <div className="bottom-nav-box">
          <BottomNav />
        </div>
        <div className="pc-nav-box">
          <PcNav/>
        </div>
        <main>{children}</main>
        <Helmet>
          {/* ION ICON cdn */}
          <script src="https://unpkg.com/ionicons@5.2.3/dist/ionicons.js"></script>
        </Helmet>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
